import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'

export const CONFIRM_STORE_DELIVERY_BREAD = 'CONFIRM_STORE_DELIVERY_BREAD'
export const confirmStoreDeliveryBreadAction = (storeDeliveryBread: StoreDeliveryBreadType) => {
  return {
    type: 'CONFIRM_STORE_DELIVERY_BREAD',
    payload: storeDeliveryBread,
  }
}

export const FETCH_STORE_DELIVERY_BREAD = 'FETCH_STORE_DELIVERY_BREAD'
export const fetchStoreDeliveryBreadAction = (storeDeliveryBread: StoreDeliveryBreadType) => {
  return {
    type: 'FETCH_STORE_DELIVERY_BREAD',
    payload: storeDeliveryBread,
  }
}

export const INIT_STORE_DELIVERY_BREAD = 'INIT_STORE_DELIVERY_BREAD'
export const initStoreDeliveryBreadAction = () => {
  return {
    type: 'INIT_STORE_DELIVERY_BREAD',
    payload: null,
  }
}
